import { render, staticRenderFns } from "./MiniSidebarLayout.vue?vue&type=template&id=4625d162&scoped=true"
import script from "./MiniSidebarLayout.vue?vue&type=script&lang=js"
export * from "./MiniSidebarLayout.vue?vue&type=script&lang=js"
import style0 from "./MiniSidebarLayout.vue?vue&type=style&index=0&id=4625d162&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4625d162",
  null
  
)

export default component.exports